import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { DSLink } from '@stihl-design-system/components';

interface LinkOutProps extends PropsWithChildren {
  href: string;
  className?: string;
  dataTestId?: string;
  allowReferrer?: boolean;
  variant?: 'highlight' | 'neutral';
  hideIcon?: boolean;
}

export const LinkOut: FC<LinkOutProps> = ({
  children,
  href,
  className,
  variant = 'highlight',
  dataTestId,
  allowReferrer = false,
  hideIcon = false,
}) => {
  const { t } = useTranslation('shared');

  const iconProps = !hideIcon ? ({ iconName: 'arrow-out', iconPosition: 'right' } as const) : null;

  return (
    <DSLink
      href={href}
      target="_blank"
      rel={allowReferrer ? undefined : 'noreferrer'}
      className={className}
      data-testid={dataTestId}
      variant={variant}
      active
      {...iconProps}
    >
      {children}
      <span className="sr-only">({t('shared_a11y_hint_opensInNewTab')})</span>
    </DSLink>
  );
};
